import React from 'react';
import InvitacionRender from '../shared/InvitacionRender';

function VistaInvitacionEvento({ fondo, codigo, nombre, layoutInvitacion }) {
  return (
    <InvitacionRender
      fondo={fondo}
      codigo={codigo}
      nombre={nombre}
      layout={layoutInvitacion}
      width={300}
    />
  );
}

// Progreso y formularios no deben volver a dibujar todos los QR del lote.
export default React.memo(VistaInvitacionEvento);
